export enum Modals {
  terms = 'terms',
  privacy = 'privacy',
}
